import React, { useState, useEffect } from 'react';
import './emailVerification.scss';
import request from '../../api/api';
import { toast, ToastContainer } from 'react-toastify';
import email_verify_bg from '../../images/email_verify_bg.png';
import { Link } from 'react-router-dom';

const Emailverified = (props) => {
   const [showResendModal, setShowResendModal] = useState(false);
   const [isVerified, setIsVerified] = useState(false);
   const [alreadyVerified, setAlreadyVerified] = useState(false);
   const [unverified, setUnverified] = useState(false);

   useEffect(() => {
      handleEmailVerification();
   }, []);

   const handleEmailVerification = async () => {
      try {
         const res = await request({
            url: `candidate/emaiverification${window.location.search}`,
            method: 'GET',
         });

         if (res.status === 1) {
            setIsVerified(true);
            toast.success(res.response);
         } else if (res.status === 2) {
            setAlreadyVerified(true);
            toast.success(res.response);
         } else if (res.status === 0) {
            setUnverified(true);
            toast.error(res.response);
         }
      } catch (err) {
         toast.error(err.message || 'Something went wrong');
      }
   };

   const resendLinkHandler = async () => {
      try { 
         const res = await request({
            url: `/candidate/emailverification/redo-validation${window.location.search}`,
            method: "GET",
         });
   
         if (res.status === 1) {
            toast.success(res.response);
            setUnverified(false);
            setShowResendModal(true);
         } else if (res.status === 0) {
            setUnverified(true);
            toast.error(res.response);
         }
      } catch (err) {
         toast.error(err.response?.data?.message || 'An error occurred while resending the link.');
      }
   };
   
   return (
      <>
         <ToastContainer position="top-right" autoClose={2500} closeOnClick />
         <section className="section login-spaces">
            {/* <div className="container verification-box-container">
               <div className="verification-box">
                  <div className="alert-icon mb-3">⚠️</div>
                  <h5 className="mb-3">Email verification required</h5>
                  <p className="text-muted mb-4">
                     Your Get Shifts email address is not yet verified. Please check your registered email for the verification email (check your spam too) and
                     follow the instructions to verify your Get Shifts account.
                  </p>
                  <div className="d-flex justify-content-center gap-3">
                     <button className="btn btn-resend px-4">Resend verification link</button>
                     <button className="btn btn-change px-4">Change Email</button>
                  </div>
               </div>
            </div> */}

            {isVerified ? (
               // <div className="email-verification" style={{ background: `url(${email_verify_bg})`, backgroundSize: 'cover', backgroundRepeat: 'no-repeat' }}>
               <div className="email-verification">
                  <div className="email-card" style={{ zIndex: 10 }}>
                     <div>
                        {/* <img src="https://www.getshifts.co.uk/uploads/images/others/1635155166671.png" alt="Getshift_logo" /> */}
                        <img src="https://www.getshifts.co.uk/uploads/images/others/1704789160480.png" alt="Getshift_logo" />
                     </div>
                     <p>Your account has been verified. Thank you</p>
                     <div className="email-ver-button">
                        <button>
                           <Link to="/login" style={{ color: 'white' }}>
                              Login
                           </Link>
                        </button>
                     </div>
                  </div>
               </div>
            ) : (
               <></>
            )}
            {alreadyVerified ? (
               // <div className="email-verification" style={{ background: `url(${email_verify_bg})`, backgroundSize: 'cover', backgroundRepeat: 'no-repeat' }}>
               <div className="email-verification">
                  <div className="email-card" style={{ zIndex: 10 }}>
                     <div>
                        <img src="https://www.getshifts.co.uk/uploads/images/others/1704789160480.png" alt="Getshift_logo" />
                     </div>
                     <p>Your account is already verified.</p>
                     <div className="email-ver-button">
                        <button>
                           <Link to="/login" style={{ color: 'white' }}>
                              Login
                           </Link>
                        </button>
                     </div>
                  </div>
               </div>
            ) : (
               <></>
            )}
            {showResendModal ? (
               // <div className="email-verification" style={{ background: `url(${email_verify_bg})`, backgroundSize: 'cover', backgroundRepeat: 'no-repeat' }}>
               <div className="email-verification">
                  <div className="email-card" style={{ zIndex: 10 }}>
                     <div>
                        <img src="https://www.getshifts.co.uk/uploads/images/others/1704789160480.png" alt="Getshift_logo" />
                     </div>
                     <p>The new verification url has been sent to your registered email address</p>
                     <div className="email-ver-button">
                        <button>Close</button>
                     </div>
                  </div>
               </div>
            ) : (
               <></>
            )}
            {unverified ? (
               // <div className="email-verification" style={{ background: `url(${email_verify_bg})`, backgroundSize: 'cover', backgroundRepeat: 'no-repeat' }}>
               <div className="email-verification">
                  <div className="email-card" style={{ zIndex: 10 }}>
                     <div>
                        <img src="https://www.getshifts.co.uk/uploads/images/others/1704789160480.png" alt="Getshift_logo" />
                     </div>
                     <p>This verification link has expired, please click below to send a new verification link.</p>
                     <div className="email-ver-button">
                        <button onClick={() => resendLinkHandler()}>Resend Email</button>
                     </div>
                  </div>
               </div>
            ) : (
               <></>
            )}
         </section>
      </>
   );
};
export default Emailverified;
